import { numberWithCommas, tonStringFromPounds } from '@/utils/NumericMutations'
import { HarvestUnits } from '@/utils/Enumerations'

export const cruiseDataTotals = (cruiseData, units = HarvestUnits.Tons) => {
  cruiseData = Array.isArray(cruiseData) ? cruiseData : [cruiseData]
  const isTons = units === HarvestUnits.Tons

  const totals = cruiseData.reduce((total, cd) => {
    total.harvested += isTons ? cd.harvested : cd.harvestedMBF
    total.expected += isTons ? cd.expected : cd.expectedMBF
    total.adjustment += isTons ? cd.adjustment : cd.adjustmentMBF
    total.cruisedValue += cd.cruisedValue
    total.remaining += isTons ? cd.remainingTons : cd.remainingMBF
    return total
  }, {
    harvested: 0,
    adjustment: 0,
    remaining: 0,
    expected: 0,
    cruisedValue: 0
  })

  totals.remaining = Math.max(totals.remaining, 0)

  totals.remaining = numberWithCommas(totals.remaining, 3)
  totals.harvested = isTons ? tonStringFromPounds(totals.harvested) : numberWithCommas(totals.harvested)
  totals.adjustment = isTons ? tonStringFromPounds(totals.adjustment) : numberWithCommas(totals.adjustment)
  totals.expected = isTons ? tonStringFromPounds(totals.expected) : numberWithCommas(totals.expected)

  return totals
}

export const volumeBasedCruiseDataTotals = (cruiseData) => {
  cruiseData = Array.isArray(cruiseData) ? cruiseData : [cruiseData]

  const totals = cruiseData.reduce((total, cd) => {
    total.harvested += cd.harvested
    total.adjustment += cd.adjustment
    total.remaining += cd.remaining
    total.expected += cd.expected
    total.obligation += cd.obligation
    total.obligationAccrued += cd.obligationAccrued ?? 0
    total.obligationBalance += cd.obligationBalance
    total.cruisedValue += cd.cruisedValue
    return total
  }, {
    harvested: 0,
    adjustment: 0,
    remaining: 0,
    expected: 0,
    obligation: 0,
    obligationAccrued: 0,
    obligationBalance: 0,
    cruisedValue: 0
  })

  totals.remaining = Math.max(totals.remaining, 0)

  return {
    harvested: numberWithCommas(totals.harvested / 1000, 3),
    adjustment: numberWithCommas(totals.adjustment / 1000, 3),
    remaining: numberWithCommas(totals.remaining / 1000, 3),
    expected: numberWithCommas(totals.expected / 1000, 3),
    obligation: totals.obligation / 1000,
    obligationAccrued: totals.obligationAccrued,
    obligationBalance: totals.obligationBalance,
    cruisedValue: totals.cruisedValue
  }
}
